module.exports = __webpack_public_path__ + "static/media/ia.cd96f8a3.svg";